export const Banner = ({ text, src = "" }) => {
  return (
    <div className="bg-deep-primary">
      <div className="max-width flex flex-col md:flex-row md:items-center justify-between">
        <div className="flex flex-col gap-5 pt-[56px] md:pt-0">
          <p className="text-white font-medium text-[32px] md:text-[42px] leading-[40px] md:leading-[52px]">
            {text}
          </p>
          <p className="text-yellow text-lg font-medium">
            Effective Date: 01/01/2025
          </p>
        </div>

        <img
          src={src}
          alt="information"
          className="block w-full max-w-[445px]"
        />
      </div>
    </div>
  );
};
